import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Button } from "@/components/Buttons";
import routes from "@/lib/routes";
import processStyles from "@/styles/Process.module.scss";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var IconComplete = function IconComplete(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "30",
      cy: "30",
      r: "30",
      transform: "translate(2 2)",
      fill: "none",
      stroke: "#09f",
      strokeWidth: "3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.674,33.177,27.1,43.116l18.862-20",
      fill: "none",
      stroke: "#09f",
      strokeWidth: "3",
      fillOpacity: "0"
    })]
  }));
};
IconComplete.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
};
export default function CompleteInquiry() {
  const router = useRouter();
  const handleClick = useCallback(() => {
    router.push(routes.home);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: `${processStyles.header} ${processStyles.cancelMb}`,
      children: [/*#__PURE__*/_jsx("div", {
        className: processStyles.icon,
        children: /*#__PURE__*/_jsx(IconComplete, {})
      }), /*#__PURE__*/_jsx("h4", {
        className: processStyles.heading,
        children: "\u304A\u554F\u3044\u5408\u308F\u305B\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F"
      })]
    }), /*#__PURE__*/_jsx(Button, {
      fillColor: true,
      large: true,
      fontFixed: true,
      onClick: handleClick,
      children: "\u30C8\u30C3\u30D7\u3078\u623B\u308B"
    })]
  });
}